// extracted by mini-css-extract-plugin
module.exports = {"clickable":"_2Yk_Z"};